import { createSlice } from "@reduxjs/toolkit";
import { PaidBookTestBooking } from "@/store/types/bookExamTypes";
import { getMyPaidBookTestBookings } from "./bookExamApi";

interface BookTestState {
	paidBookings: PaidBookTestBooking[];
	paidBookingsLoading: boolean;
	paidBookingsError: string | null;
}

const initialState: BookTestState = {
	paidBookings: [],
	paidBookingsLoading: false,
	paidBookingsError: null,
};

const bookTestSlice = createSlice({
	name: "bookTest",
	initialState,
	reducers: {},
	extraReducers: (builder) => {
		builder
			.addCase(getMyPaidBookTestBookings.pending, (state) => {
				state.paidBookingsLoading = true;
				state.paidBookingsError = null;
			})
			.addCase(getMyPaidBookTestBookings.fulfilled, (state, action) => {
				state.paidBookingsLoading = false;
				state.paidBookings = action.payload;
			})
			.addCase(getMyPaidBookTestBookings.rejected, (state, action) => {
				state.paidBookingsLoading = false;
				state.paidBookingsError =
					action.payload || "Failed to fetch paid bookings.";
			});
	},
});

export default bookTestSlice.reducer;
